module.exports = __webpack_public_path__ + "img/pdf-icon.735a0c5e.svg";